module.exports = __webpack_public_path__ + "img/202509-2_04.e6436227.jpg";